module.exports = __webpack_public_path__ + "static/media/PayAtRestaurantScreen.de66b6ef.png";